import {CurrencyPipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'emAmount',
})
export class AmountPipe extends CurrencyPipe implements PipeTransform {
  // @ts-ignore
  transform(value: number, ...args: any[]): any {
    const noDecimal = !!args.find((x) => x === 'noDecimal');
    const noDollarSign = !!args.find((x) => x === 'noDollarSign');

    if (noDecimal) {
      return super.transform(value, 'CAD', 'symbol-narrow', '1.0-0');
    } else if (noDollarSign) {
      return super.transform(value, 'CAD', '');
    } else {
      return super.transform(value, 'CAD', 'symbol-narrow');
    }
  }
}
